import { Link } from '@inertiajs/react'
import type { ReactNode } from 'react'
import type { NavLink } from '@/layouts/navigation'

type Props = { link: NavLink; className?: string; children?: ReactNode }

/** 画面内のリンクは Inertia の <Link>（フルリロードしない）、外部サイトとログアウトは <a> */
export function AppLink({ link, className, children }: Props) {
  const content = children ?? link.label
  if (link.external || link.newTab) {
    return (
      <a className={className} href={link.href} target={link.newTab ? '_blank' : undefined} rel={link.newTab ? 'noreferrer' : undefined}>
        {content}
      </a>
    )
  }
  return (
    <Link className={className} href={link.href}>
      {content}
    </Link>
  )
}
